import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Summary = ({summaryData,getShowPlans}) => {


   
   
  const handleBack=()=>{
    getShowPlans(true)
  }

  return (
    <div className="container mt-5">
      <div className="text-center">
        <div  className="card p-4 shadow-lg border-0">
          <h2
            className="fw-bold mb-3"
            style={{ fontSize: "24px", color: "#344567" }}
          >
            Thank you. Your order has been received.
          </h2>
          <h5 className="text-muted mb-4">Order Details</h5>
          <p className="mt-3" style={{color:'#000'}}>
            <strong>Reference Number:</strong>{" "}
            <span className="text-muted">
              {summaryData?.reference_number}
            </span>
            <br />
            <strong>Date:</strong>{" "}
            <span className="text-muted">
              {summaryData?.order_date}
            </span>
            <br />
          </p>

          <div className="oc-table mt-4">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-light bg-light">
                  <tr>
                  <th className="text-left" style={{ color: "#344567" }}>
                      Sl.no
                    </th>

                    <th className="text-left" style={{ color: "#344567" }}>
                      PRODUCT
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      QTY
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData?.order_details.map((data, index) => (
                    <tr key={index}>
                      <td> {index+1}</td>
                      <td>{data?.product_name}</td>
                      <td className="text-center">{data?.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          



          {summaryData?.collecting_address?.collector_name ? (
            <div className="row mt-5">
              {/* Address Details */}
              <div className="col-lg-6">
                <div className="bg-light p-4 rounded shadow-sm">
                  <h6
                    className="fw-bold mb-3"
                    style={{ color: "#344567", fontSize: "18px" }}
                  >
                    Collecting Person's Details
                  </h6>
                  <p className="mb-1"> Name:{summaryData.collecting_address.collector_name}</p>
                  <p>
                    Collection Date: {(() => {
                      const [year, month, day] = summaryData.collecting_address.collect_date.split(" ")[0].split("-");
                      return `${month}-${day}-${year}`;
                    })()}
                  </p>


                  <p> Email:{summaryData.collecting_address.collector_email}</p>
                  <p className="text-muted small mt-3" style={{ fontSize: "12px" }}>
                    <span className="text-danger">*</span> If the details are incorrect,
                    please contact Telsim Retailer Support to change the collector details
                    before confirming the order.
                  </p>
                </div>
              </div>
            </div>
          ) : summaryData?.billing_address ? (
            <div className="row mt-5">
              {/* Address Details */}
              <div className="col-lg-6">
                <div className="bg-light p-4 rounded shadow-sm">
                  <h6
                    className="fw-bold mb-3"
                    style={{ color: "#344567", fontSize: "18px" }}
                  >
                    Address Details
                  </h6>
                  <p className="mb-1">{summaryData.billing_address.retailer_company_name}</p>
                  <p>{summaryData.billing_address.address}</p>
                  <p className="text-muted small mt-3" style={{ fontSize: "12px" }}>
                    <span className="text-danger">*</span> If the address details are
                    incorrect, please contact Telsim Retailer Support to change the
                    delivery address before confirming the order.
                  </p>
                </div>
              </div>
            </div>
          ) : null}

      <button style={{margin:"10px", backgroundColor:"#e20e75",borderRadius:"5px" ,border:"none" ,color:"white",padding:"3px",fontSize:"19px",width:"134px"}}  onClick={handleBack} > Back</button>
        </div>
      </div>
    </div>
  );
};

export default Summary;
